<template>
  <Advice
    img="question"
    priority="low-white"
    class="p-contentplans-writing-user-advice"
  >
    <template slot="title">
      <p>ここをチェック！</p>
    </template>
    <ul class="p-contentplans-writing-user-advice-list">
      <li class="p-contentplans-writing-user-advice-list__item">
        <IconDefault type="check" :size="16" />見出しの中に、<span
          class="c-text--bold c-text--marker"
          >自社独自の情報</span
        ><Tooltip size="sm">
          <div class="c-text--free">
            <p>
              上位を目指すには、網羅性と同様に独自性を向上させることが必須です。そのためには、以下のような方法が有効です。
            </p>
            <ol class="c-list--decimal">
              <li>上位ページの情報ソース（引用元）を変える</li>
              <li>
                自社独自の事例やデータを記載する
              </li>
              <li>
                筆者自身の体験や意見を入れる
              </li>
              <li>競合ページにない見出しを追加する</li>
              <li>
                ユーザーの知識や理解度・ニーズに合わせた表現を用いる
              </li>
            </ol>
          </div> </Tooltip
        >を追加できていますか？
      </li>
      <li class="p-contentplans-writing-user-advice-list__item">
        <IconDefault type="check" :size="16" /><span
          class="c-text--bold c-text--marker"
          >E-E-A-T（経験・専門性・権威性・信頼性）は担保</span
        >
        できていますか？<a
          href="https://www.plan-b.co.jp/blog/seo/24741/"
          target="_blank"
          class="c-link--blank"
          >E-E-A-Tについて</a
        >
      </li>
      <li class="p-contentplans-writing-user-advice-list__item">
        <IconDefault type="check" :size="16" />見出しの内容や順序は、<span
          class="c-text--bold c-text--marker"
          >ユーザーの検索意図を満たす</span
        >ものになっていますか？
      </li>
    </ul>
  </Advice>
</template>

<script>
import Advice from '@/components/Advice';
import IconDefault from '@/components/icon/IconDefault';
import Tooltip from '@/components/Tooltip';

export default {
  components: {
    Advice,
    IconDefault,
    Tooltip
  }
};
</script>
